import { ReactElement } from 'react';
import { IFragmentCtaFields, IFragmentInsurance } from 'types/contentful';
import CTA from 'components/UI/Cta';

interface InsuranceProps {
  heading: string;
  insurances: IFragmentInsurance[];
  disclaimer?: string | undefined;
  cta: IFragmentCtaFields | undefined;
}
export default function NewInsuranceProviders({
  heading,
  insurances,
  disclaimer,
  cta,
}: InsuranceProps): ReactElement {
  const sortedInsurances = [...insurances].sort((a, b) =>
    a.fields.insurer.localeCompare(b.fields.insurer)
  );
  const itemsPerColumn = Math.ceil(sortedInsurances.length / 3);
  const insuranceColumns = Array.from({ length: 3 }, (_, index) =>
    sortedInsurances.slice(index * itemsPerColumn, (index + 1) * itemsPerColumn)
  ).filter((column) => column.length > 0);
  const itemsPerColumnMobile = Math.ceil(sortedInsurances.length / 2);
  const insuranceColumnsMobile = Array.from({ length: 2 }, (_, index) =>
    sortedInsurances.slice(index * itemsPerColumnMobile, (index + 1) * itemsPerColumnMobile)
  ).filter((column) => column.length > 0);

  return (
    <div className="ecp-my bg-muted" id="accepted-insurances-section">
      <div className="mx-auto px-site-component py-10 md:py-20 text-primary-actual">
        <div className="flex items-center mb-8 lg:mb-10">
          <h5 className="bordered-heading bh-location-heading-item font-light text-new-34 lg:text-4xl lg:leading-new-43">
            {heading}
          </h5>
        </div>

        <div className="hidden md:grid grid-cols-2 gap-x-8 lg:gap-y-6 lg:grid-cols-3 space-y-2 lg:space-y-0">
          {insuranceColumns.map((column, columnIndex) => (
            <ul key={columnIndex} className="list-none text-lg space-y-2">
              {column.map((insurance, insuranceIndex) => (
                <li
                  key={`${insurance.fields.insurer}-${insuranceIndex}`}
                  className="leading-relaxed whitespace-nowrap-ellipses overflow-hidden"
                >
                  {insurance.fields.insurer}
                </li>
              ))}
            </ul>
          ))}
        </div>
        <div className="md:hidden grid grid-cols-2 gap-x-8 lg:gap-y-6 lg:grid-cols-3 space-y-2 lg:space-y-0">
          {insuranceColumnsMobile.map((column, columnIndex) => (
            <ul key={columnIndex} className="list-none text-lg space-y-2">
              {column.map((insurance, insuranceIndex) => (
                <li
                  key={`${insurance.fields.insurer}-${insuranceIndex}`}
                  className="leading-relaxed whitespace-nowrap-ellipses overflow-hidden"
                >
                  {insurance.fields.insurer}
                </li>
              ))}
            </ul>
          ))}
        </div>

        {disclaimer && (
          <div className="mx-auto mt-8 text-left text-lg md:mt-10 md:mb-8">{disclaimer}</div>
        )}

        {cta ? (
          <div className="mt-6 flex justify-center">
            <CTA
              {...cta}
              classNames="bg-white button-text text-primary-actual border border-secondary rounded-full"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
